export const SECURITY_ON_CHANGE = 'SECURITY_ON_CHANGE';
export const TRAVEL_APPROVAL_REQUESTS = 'TRAVEL_APPROVAL_REQUESTS';

